import React, { useRef, useState } from "react";
import { Popup } from "devextreme-react";
import { openPopup } from "@/helper/DxHelper";
import { moreIconContent } from "../UP/HiddenOption";
import { PopupRef } from "devextreme-react/cjs/popup";

type Props = {
  showHiddenRows: boolean;
  setShowHiddenRows: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function HiddenOption({ setShowHiddenRows, showHiddenRows }: Props) {
  const [isActive, setIsActive] = useState(false);
  const popupRef = useRef<PopupRef>(null);

  const optionsButtonElement = document.getElementById("options-btn-npv");

  return (
    <div className="ml-auto print:hidden">
      <button
        id="options-btn-npv"
        className={`hover:bg-primary rounded-md px-[0.6875rem] py-[1.125rem] transition-all duration-300 hover:shadow-default [&>svg]:stroke-neutral-200 [&>svg]:hover:stroke-white ${
          isActive ? "bg-primary [&>svg]:stroke-white" : "bg-transparent"
        }`}
        onClick={() => openPopup(popupRef)}
      >
        {moreIconContent}
      </button>
      <Popup
        width={188}
        height="fit"
        ref={popupRef}
        id="hidden-options-popup"
        onShowing={(e) => {
          const el = e.component.content();
          el.style.padding = "0";
          setIsActive(true);
        }}
        onHiding={() => setIsActive(false)}
        hideOnOutsideClick={true}
        showTitle={false}
        shading={false}
        position={{
          my: "bottom",
          at: "left",
          of: "#options-btn-npv",
          collision: "fit",
          offset: { x: -55, y: -25 },
        }}
        container={optionsButtonElement!}
      >
        <div className="self-end">
          <button
            className="hover:bg-secondary flex w-full px-2 py-3 text-sm"
            onClick={() => {
              setShowHiddenRows((prev) => !prev);
            }}
          >
            {showHiddenRows ? "Hide" : "Show"} extra rows
          </button>
        </div>
      </Popup>
    </div>
  );
}
